import { useCallback } from 'react'

import { EMPTY_OBJECT } from '../../../constants/common'
import { preventDefault } from '../../../utils/events'

export function useTableRowActions(
  { item, onCallAction, onClick, onMouseDown, onSelect, onSetFocusedRow },
  { getOnClickProps, itemIdKey } = EMPTY_OBJECT
) {
  const id = item[itemIdKey] || item.id

  const handleCallAction = useCallback(
    (action, item) => {
      onCallAction?.(action?.value, item)
    },
    [onCallAction]
  )

  const handleClick = useCallback(
    event => {
      onClick?.(getOnClickProps?.(item) || id, event)
    },
    [getOnClickProps, id, item, onClick]
  )

  const handleMouseDown = useCallback(
    event => {
      preventDefault(event)

      onMouseDown?.(getOnClickProps?.(item) || id, event)
    },
    [getOnClickProps, id, item, onMouseDown]
  )

  const handleMouseEnter = useCallback(() => {
    onSetFocusedRow?.(id)
  }, [id, onSetFocusedRow])

  const handleMouseLeave = useCallback(() => {
    onSetFocusedRow?.(null)
  }, [onSetFocusedRow])

  const handleSelect = useCallback(
    isChecked => {
      onSelect?.(item, isChecked)
    },
    [item, onSelect]
  )

  return {
    handleCallAction,
    handleClick,
    handleMouseDown,
    handleMouseEnter,
    handleMouseLeave,
    handleSelect,
  }
}
